const LOCATION_FIELD_TYPE = "locationPin";

const isValidCoordinate = (value) =>
  value &&
  typeof value.latitude === "number" &&
  typeof value.longitude === "number" &&
  value.latitude >= -90 &&
  value.latitude <= 90 &&
  value.longitude >= -180 &&
  value.longitude <= 180;

const parseCoordinate = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const formatLocation = (location) => {
  if (!isValidCoordinate(location)) {
    return "";
  }

  return `${location.latitude.toFixed(6)}, ${location.longitude.toFixed(6)}`;
};

const getGoogleMapsUrl = (location) => {
  if (!isValidCoordinate(location)) {
    return "";
  }

  return `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`;
};

export {
  LOCATION_FIELD_TYPE,
  formatLocation,
  getGoogleMapsUrl,
  isValidCoordinate,
  parseCoordinate,
};
